import {
    BooleanInput,
    ChoiceInput,
    CodeInput,
    EdsChoiceInput,
    ErrorInput,
    NodeInputProps,
    NumberInput,
    TextInput,
    MultiChoice,
    BooleanString,
    ListInput,
    KeyValuesInput,
    ArrayInput,
    PipelineChoiceInput,
} from "../components/form-format";

import {FunctionComponent} from "react";
import {StringInput} from "../components/form-format/string";
import {Input} from "../components/form-format/input";
import {PasswordInput} from "../components/form-format";
import { AvroInput } from "../components/form-format/avro/Avro";
import { MapStringAny } from "../components/form-format/Map/Map";

export const forms = new Map<string, FunctionComponent<NodeInputProps>>();
forms.set("number", NumberInput);
forms.set("choice", ChoiceInput);
forms.set("edsChoice", EdsChoiceInput);
forms.set("boolean", BooleanInput);
forms.set("codeparsed", CodeInput);
forms.set("code", CodeInput);
forms.set("string", StringInput);
forms.set("text", TextInput);
forms.set("list", ListInput);
forms.set("input", Input); // specific
forms.set("multichoice",MultiChoice)
forms.set("booleanstring",BooleanString)
forms.set("password", PasswordInput)
forms.set("avro", AvroInput)
forms.set("keyValues", KeyValuesInput);
forms.set("array", ArrayInput);
forms.set("map", MapStringAny);
forms.set("pipelineChoice", PipelineChoiceInput);

let typeReg = new RegExp(/(.*)\[(.*)\]/)
export const useNodeForm = () => {
    const getForm = (type: string): FunctionComponent<NodeInputProps> => {
        if (type) {
            // simple type
            if (forms.has(type)){
                return forms.get(type)!
            }

            if (type.startsWith('list')){
                return forms.get("list")!
            }

            /* non-list*/
            let m = type.match(typeReg)
            if (m && m.length > 0) {
                return forms.get(m[1]) || ErrorInput
            }
        }

        return ErrorInput
    }
    return {
        getForm
    }
}